import { Box, Grid, styled, Table, TableBody, TableCell, TableRow, useTheme } from "@mui/material";
import type { FC } from "react";
import { makeRenderPaddingPxs } from "../../email-design/util";
import { ConditionalWrapper } from "../../generic/components/conditional-wrapper";
import { useStyleableColumns } from "../../message/editor/utils/use-styleable-columns";
import { HoverBadge } from "../hover-badge";
import type { PreviewProps } from "./types";

export const ColumnsPreview: FC<PreviewProps> = (props) => {
  const { layout_settings, text_settings } = props.data;
  const stylableColumns = useStyleableColumns();
  const theme = useTheme();
  const Paragraph = styled("p")`
    margin: 0;
    padding: 0 0 ${layout_settings?.paragraph_padding}px 0;
    font-family: ${text_settings?.font ?? "arial"};
    font-size: ${text_settings?.font_size}px;
    color: ${text_settings?.font_colour};
    line-height: ${text_settings?.line_height};
  `;

  const cell = (text: string): React.JSX.Element => (
    <TableCell
      sx={{
        ...(stylableColumns.enabled
          ? makeRenderPaddingPxs(layout_settings)
          : {
              padding:
                layout_settings?.column_spacing_type === "padding"
                  ? `${layout_settings?.column_padding ?? 0}px`
                  : "0px", // this now matches the 0 padding in the lexical editor,
            }),
        backgroundColor: theme.palette.background.active,
      }}
    >
      <Paragraph>{text}</Paragraph>
      <Paragraph>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
        labore et dolore magna aliqua. Fringilla urna porttitor rhoncus dolor purus non enim
        praesent.
      </Paragraph>
    </TableCell>
  );

  return (
    <Grid>
      <ConditionalWrapper
        condition={props.badgeProps !== undefined}
        wrapper={(children) => (
          <HoverBadge badgeContent={"Columns"} name={"layout"} {...props.badgeProps}>
            {children}
          </HoverBadge>
        )}
      >
        <Box>
          <Table
            sx={{
              ...(stylableColumns.enabled
                ? {
                    borderCollapse: "collapse",
                    borderSpacing: 0,
                  }
                : {
                    borderCollapse:
                      layout_settings?.column_spacing_type === "spacing" ? "unset" : "collapse",
                    borderSpacing:
                      layout_settings?.column_spacing_type === "spacing"
                        ? `${layout_settings?.column_spacing ?? 0}px 0px`
                        : undefined,
                  }),
              tableLayout: "fixed",
            }}
          >
            <TableBody>
              <TableRow>
                {cell("Column 1")}
                {cell("Column 2")}
                {cell("Column 3")}
              </TableRow>
            </TableBody>
          </Table>
        </Box>
      </ConditionalWrapper>
    </Grid>
  );
};
